import React, { useState } from "react";
import UpdateRiderAvaiabilityStatus from './UpdateRiderAvaiabilityStatus';
import { Modal, ModalBody } from "reactstrap";
import { reduxForm } from "redux-form";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress } from '@mui/material';

const UpdateRiderAvaiabilityStatusModal = ({ open, setOpen, isTitle, dataInfo }) => {
    const [loading, setLoading] = useState(false);

    const toggle = () => {
        if (!loading) {
            setOpen(prevState => !prevState);
        }
    }

    return (
        <div>
            <Modal
                isOpen={open}
                toggle={toggle}
                modalClassName="ltr-support"
                className="theme-light ltr-support"
                size="lg"
                backdrop={loading ? "static" : true}
                style={{ maxWidth: '700px' }}
            >
                {/* Modern Modal Header */}
                <div
                    className="position-relative"
                    style={{
                        background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)', // Fresh green gradient for availability
                        padding: '1.5rem 2rem',
                        borderRadius: '0.5rem 0.5rem 0 0',
                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                    }}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <div
                                className="d-flex align-items-center justify-content-center me-3"
                                style={{
                                    width: '48px',
                                    height: '48px',
                                    background: 'rgba(255,255,255,0.2)',
                                    borderRadius: '12px',
                                    backdropFilter: 'blur(10px)'
                                }}
                            >
                                <EventAvailableIcon style={{ fontSize: '28px', color: '#fff' }} />
                            </div>
                            <div>
                                <h4
                                    className="m-0 text-white fw-bold"
                                    style={{
                                        fontSize: '1.4rem',
                                        letterSpacing: '0.5px',
                                        textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {isTitle}
                                </h4>
                                <p className="m-0 text-white-50 small">
                                    Update rider availability status and schedule
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={toggle}
                            disabled={loading}
                            className="btn-close-custom"
                            style={{
                                background: 'rgba(255,255,255,0.2)',
                                border: 'none',
                                borderRadius: '50%',
                                width: '36px',
                                height: '36px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                opacity: loading ? 0.5 : 1
                            }}
                            onMouseEnter={(e) => {
                                if (!loading) {
                                    e.currentTarget.style.background = 'rgba(255,255,255,0.3)';
                                    e.currentTarget.style.transform = 'rotate(90deg)';
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.2)';
                                e.currentTarget.style.transform = 'rotate(0deg)';
                            }}
                        >
                            <CloseIcon style={{ color: '#fff', fontSize: '20px' }} />
                        </button>
                    </div>
                </div>

                {/* Modal Body */}
                <ModalBody className="p-0" style={{ background: '#f8f9fa' }}>
                    {loading && (
                        <div
                            className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
                            style={{
                                background: 'rgba(255,255,255,0.85)',
                                zIndex: 1050,
                                backdropFilter: 'blur(4px)'
                            }}
                        >
                            <div className="text-center">
                                <CircularProgress size={45} style={{ color: '#11998e' }} />
                                <p className="mt-2 text-muted fw-bold small">Processing...</p>
                            </div>
                        </div>
                    )}

                    <div className="p-4" style={{ maxHeight: 'calc(90vh - 120px)', overflowY: 'auto' }}>
                        <UpdateRiderAvaiabilityStatus
                            dataInfo={dataInfo}
                            setLoading={setLoading}
                        />
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default reduxForm({ form: 'UpdateRiderAvaiabilityStatusModalForm', enableReinitialize: true })(UpdateRiderAvaiabilityStatusModal);